import React, { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client';
import { Card, Grid, Typography, ListItemText } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

import { ErrorComponent, LoadingSpinner } from '../../../../components';
import { PublishableStatusComponent } from '../../../../components/PublishableStatusComponent';
import { userLanguage } from '../../../../core/AuthContext';

import AccessoryModelsList from '../AccessoryModelsList';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import AccessoryUpdateDialog from '../AccessoryUpdateDialog';
import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import { PlatformNavigation } from '../../navigation/PlatformNavigation';
import { successNotification } from '../../../../core/utils';
import { toast } from 'react-toastify';

interface IProps {
  party: GQLParty;
}

const AccessoryDetails: React.FC<IProps> = ({ party }: IProps) => {
  const [errorComponentState, setErrorComponentState] = useState(false);
  const [isCreateAccessoryDialogOpen, setIsCreateAccessoryDialogOpen] = useState(false);

  const accessoryId = PlatformNavigation.accessoryDetails.paramsFromPath(useRouteMatch()).accessoryId;

  const { loading, error, refetch, networkStatus, data } = GQLOperationBuilder.accessory.getAccessory({
    accessoryId: accessoryId
  });

  if (loading || networkStatus === NetworkStatus.refetch) return <LoadingSpinner />;

  if (error && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={error?.stack}
        callback={refetch}
        message={error?.message}
      />
    );

  return (
    <Grid container direction="row">
      <Grid item md={6} style={{ marginBottom: '8px' }}>
        <Card style={{ padding: '8px' }}>
          <div style={{ display: 'flex' }}>
            <Typography style={{ marginRight: '2px' }} variant={'h6'}>
              Accessory Details
            </Typography>
            <EditIcon
              fontSize="small"
              style={{ cursor: 'pointer' }}
              onClick={() => setIsCreateAccessoryDialogOpen(true)}
            />
          </div>
          <PublishableStatusComponent
            text="Accessory publishable"
            status={GQLOperationBuilder.accessory.accessoryAssetFromResponse(data).isPublishable}
          />
          <ListItemText
            primary="Accessory name"
            secondary={
              GQLOperationBuilder.accessory.accessoryAssetFromResponse(data).accessory.title[userLanguage]
            }
          />
        </Card>
      </Grid>

      <AccessoryModelsList
        party={party}
        accessoryId={accessoryId}
        accessoryModels={GQLOperationBuilder.accessory.accessoryAssetFromResponse(data).accessory.models}
      />

      {isCreateAccessoryDialogOpen && (
        <AccessoryUpdateDialog
          accessory={GQLOperationBuilder.accessory.accessoryAssetFromResponse(data)}
          party={party}
          onClose={success => {
            if (success === true) {
              successNotification(toast, 'Accessory updated successfully', () => {});
            }
            setIsCreateAccessoryDialogOpen(false);
          }}
        />
      )}
    </Grid>
  );
};

export default AccessoryDetails;
